/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FailedInputs */

const en_failed = /** @type {(inputs: FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const fr_failed = /** @type {(inputs: FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échoué`)
};

const de_failed = /** @type {(inputs: FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagen`)
};

const it_failed = /** @type {(inputs: FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallito`)
};

const ru_failed = /** @type {(inputs: FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неуспешный`)
};

const es_failed = /** @type {(inputs: FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallido`)
};

const zh_cn2_failed = /** @type {(inputs: FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败的`)
};

const ja_failed = /** @type {(inputs: FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失敗した`)
};

const hi_failed = /** @type {(inputs: FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असफल`)
};

const pt_pt2_failed = /** @type {(inputs: FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fracassado`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed = /** @type {((inputs?: FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_failed(inputs)
	if (locale === "de") return de_failed(inputs)
	if (locale === "it") return it_failed(inputs)
	if (locale === "ru") return ru_failed(inputs)
	if (locale === "es") return es_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_failed(inputs)
	if (locale === "ja") return ja_failed(inputs)
	if (locale === "hi") return hi_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_failed(inputs)
	return en_failed(inputs)
});